<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add a New Client User</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Client:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <ClientAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchClient"
                :searchOn="'searched_clients'"
                @event-name="handleChildEvent"
              ></ClientAutocomplete>
            </div>
            <span class="text-danger text-sm mt-2 ml-16">{{
              client_validation
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>First Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="first_name"
                v-model="users.first_name"
                v-validate="'required'"
                data-vv-as="First Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('first_name')"
              >{{ errors.first("first_name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Surname:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="surname"
                v-model="users.surname"
                v-validate="'required'"
                data-vv-as="Surname"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('surname')"
              >{{ errors.first("surname") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Job Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="job_role"
                v-model="users.job_role"
                data-vv-as="Job Role"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Desk Phone:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="desk_phone"
                v-model="users.desk_phone"
                data-vv-as="Desk Phone"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('desk_phone')"
              >{{ errors.first("desk_phone") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Softphone:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="softphone"
                v-model="users.softphone"
                data-vv-as="Softphone"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('softphone')"
              >{{ errors.first("softphone") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Mobile No.:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="mobile_no"
                v-model="users.mobile_no"
                data-vv-as="Mobile No."
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('mobile_no')"
              >{{ errors.first("mobile_no") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Alternate Phone 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_1"
                v-model="users.alternate_phone_1"
                data-vv-as="Alternate Phone 1"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('alternate_phone_1')"
              >{{ errors.first("alternate_phone_1") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Alternate Phone 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_2"
                v-model="users.alternate_phone_2"
                data-vv-as="Alternate Phone 2"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('alternate_phone_2')"
              >{{ errors.first("alternate_phone_2") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>User Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                v-validate="'required'"
                required
                label="user_status"
                name="selected_user_status"
                :options="userStatusList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="users.selected_user_status"
                data-vv-as="User Status"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('selected_user_status')"
              >{{ errors.first("selected_user_status") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                v-validate="'required'"
                required
                name="role"
                label="role"
                :options="clientRoleTypes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="users.role"
                data-vv-as="User Role"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('role')"
              >{{ errors.first("role") }}</span
            >
          </div>
   
          <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Manager:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="full_name"
                :options="clientManagers"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="users.selected_manager"
              />
            </div>
          </div> -->

          <vs-divider class="m-5" />

          <!-- Head Office -->
          <h5 class="mb-5">Login Details</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Email Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              <input type="text" name="email" class="w-full custom-input" v-model="users.email" v-validate="'email|required'" data-vv-as="Email Address"/>

              <!-- <vs-input
                class="w-full"
                v-model="users.email"
                name="email"
                v-validate="'required'"
                data-vv-as="Email Address"
              /> -->
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('email')"
              >{{ errors.first("email") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Password:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <input autocomplete="new-password" :type="type" name="password" class="w-full custom-input" v-model="users.password" v-validate="'required'" data-vv-as="Password"/>


              <!-- <vs-input
                type="password"
                class="w-full"
                name="password"
                v-model="users.password"
                v-validate="'required'"
                data-vv-as="Password"
              /> -->
            </div>
            <i
              style="border-left:0px;"
              @click="type = type == 'password' ? 'text' : 'password'"
              :class="[
                type == 'password'
                  ? 'vs-icon vs-input--icon-custom vs-input--icon feather icon icon-eye icon-after'
                  : 'vs-icon vs-input--icon vs-input--icon-custom feather icon icon-eye-off icon-after'
              ]"
            ></i>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('password')"
              >{{ errors.first("password") }}</span
            >
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import moduleClientUserManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data() {
    return {
      client_validation: null,
      type: "password",
                              abilities : null,

      companySearchComponentKey: 0,
      clientManagers: [],
      clientRoleTypes: [],
      userStatusList: [],
      clients: [],
      users: {
        first_name: null,
        surname: null,
        desk_phone: null,
        softphone: null,
        mobile_no: null,
        alternate_phone_1: null,
        alternate_phone_2: null,
        job_role: null,
        email: null,
        password: null,
        role: null,
        selected_user_status: null,
        selected_role: {},
        selected_manager: null,
        manager: null,
        client_id: null
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleClientUserManagement,
    ClientAutocomplete,
    moduleClientManagement
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    }); 
    if (!moduleClientUserManagement.isRegistered) {
      this.$store.registerModule(
        "clientUsersManagement",
        moduleClientUserManagement
      );
      moduleClientUserManagement.isRegistered = true;
    }
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  },
  mounted() {
    this.getClientRoleTypes();
    this.getClientUserStatus()
    // this.getVerticals();
  },
  methods: {
    handleChildEvent() {
      this.clientManagers = []
      this.clients = moduleClientManagement.state.searched_clients;
      this.users.client_id = this.clients.id;
      this.getClientManagers(this.users.client_id)
    },
    goBack: function() {
      this.$router.go(-1);
    },
    getClientUserStatus() {
      this.$store
        .dispatch("clientUsersManagement/getClientUserStatus")
        .then(res => {
          this.userStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    searchClient(inputValue) {
      return this.$store
        .dispatch("clientsManagement/searchClient", inputValue)
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    submitForm() {
      let self = this
      self.$validator.validateAll().then(result => {
        if (result) {

          if (self.clients.length === 0) {
            self.client_validation = "Client field is required";
            return false;
          }



          if (self.users.role != null) {
            self.users.selected_role = self.users.role;
          }
          if (self.users.selected_manager != null) {
            self.users.manager = self.users.selected_manager.id;
          }
          self.addClientUsers();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    addClientUsers() {
      this.$store
        .dispatch("clientUsersManagement/addClientUser", this.users)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "User Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Client User Added",
              text: "The client user was added successfully"
            });
            this.$router.push({ path: "/client-users" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getClientRoleTypes() {
      this.$store
        .dispatch("clientUsersManagement/getClientRoleTypes")
        .then(res => {
          this.clientRoleTypes = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getClientManagers(clientId) {
      this.$store
        .dispatch("clientUsersManagement/getClientManagers",clientId)
        .then(res => {
          this.clientManagers = res.data;
          this.clientManagers = this.clientManagers.filter(function(ele) {
            ele.full_name = ele.first_name + " " + ele.surname;
            return ele;
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

[dir="ltr"] .vs-input--icon.feather {
  padding: 0.9rem 2rem 0.2rem 0.2rem;
  position: relative;
}

.vs-input--icon-custom.feather {
  top: auto;
  position: absolute;

}
.custom-input{
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
}
</style>
